import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const FieldName = ({ value }) => {
  return (
    <div data-testid="field-name-cell" className="field-name-cell">
      <div className="details">
        <div className="cell-header">Field Name</div>
        <span className="name">{value}</span>
      </div>
    </div>
  );
};

FieldName.propTypes = {
  value: PropTypes.string.isRequired,
};

export default FieldName;
